import { CommandBarButton, PanelType, Spinner, Stack, Panel } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import { Query } from 'react-apollo';
import { MyContext } from '../../../context';
import ContentUnderstandingListView from './ContentUnderstandingListView';
import * as query from '../AIQuestion/AIQuestionQuery';
import * as queryAIAssistant from './ContentUnderstandingQuery';
import EditContentUnderstandingContainer from '../ContentUnderstanding/Panels/EditContentUnderstandingContainer'
import AlertBar from '../../CustomComponents/AlertBar';
import SafetyDialog from '../../CustomComponents/SafetyDialog'
import Utils from '../../common/Utils'
import TenantAiConfigDlg from '../AIAssistant/AiConnectorGlobalConfig/TenantAiConfigDlg.jsx';

const orderAlphabetically  = Utils.orderAlphabetically

export default class ContentUnderstanding extends Component {
    static contextType = MyContext

    constructor(props) {
        super(props);
        this.state = {
            isPanelOpen: false,
            aiAssistantId: null,
            warningMessage: "",
            panelTitle: null,
            alertMessagePanel: "",
            hideDialogDelete: true,
            hideDialogAiGlobalConfig: true,
            isProcessing: false
        };
    }

    groupsCollapsed = []

    openPanel = (title, aiAssistantId) => {
        if (title === "addContentUnderstandingField" || (title === "editContentUnderstandingField" && aiAssistantId !== null)) {
            this.setState({
                isPanelOpen: true,
                panelTitle: title,
                warningMessage: ""
            })
        } else {
            this.setState({
                warningMessage: this.context.getTranslation("compliance", "selectContentUnderstandingAttribute"),
                alertType: "warning"
            })
        }

    }

    getHeaderPanel = () => {
        return (
            <div style={{ flex: "auto", marginLeft: "20px", width: "10px" /*This is located in a flex. It will grow*/}}>
                <div role="heading" aria-level="1" style={{ fontSize: "20px", fontWeight: "600" }}>{this.context.getTranslation("compliance", this.state.panelTitle)}</div>
                <AlertBar
                    message={this.state.alertMessagePanel}
                    alertType={"error"}
				isMultiline={true}
                    clearAlert={this.clearAlert}
                />
            </div >
        )
    }

    hidePanel = () => {
        this.setState({ isPanelOpen: false, alertMessagePanel: "" });
    };

    selectAIAssistant = (id) => {
        this.setState({
            aiAssistantId: id,
            warningMessage: ""
        });
    }

    setMessageError = (message) => {
        this.setState({
            alertMessagePanel: message
        })
    }

    refreshAIAssistant = () => {
        this.refetchQueryAIAssistant()
    }

    refetchQueryAIAssistant = null;

    deleteAIAssistant = () => {
        this.setState({ hideDialogDelete: true, isProcessing: true })
        if (this.state.aiAssistantId !== null) {
            const id = this.state.aiAssistantId
            this.props.apol
                .mutate({
                    mutation: query.deleteAIQuestion,
                    variables: { id }
                })
                .then((result) => {
                    if (result.data.deleteAIQuestion.status !== "ok") {
                        this.setState({
                            warningMessage: this.context.getTranslation("compliance", result.data.deleteAIQuestion.text),
                            alertType: "error",
                            isProcessing: false
                        })
                    } else {
                        this.setState({
                            aiAssistantId: null,
                            isProcessing: false
                        })
                        this.refetchQueryAIAssistant();
                    }
                });
        }
    }

    openDialogDelete = () => {
        if (this.state.aiAssistantId !== null) {
            this.setState({ hideDialogDelete: false })
        } else {
            this.setState({
                warningMessage: this.context.getTranslation("compliance", "selectAIAssistant"),
                alertType: "warning"
            })
        }
    }

    openDialogAiGlobalConf = () => {
          this.setState({ hideDialogAiGlobalConfig: false })
    }

    getAIAssistantGroups = (data) => {
        //unique groups id
        let allGroupsIds = [...new Set(data.map(aiQ => aiQ.aiQuestionGroup.id))];
        let allTemplateGroupsIds = [... new Set(data.filter(aiQ => aiQ.aiQuestionGroup.generalGroup).map(aiQ => aiQ.aiQuestionGroup.id))]
        //create groups for dataillist
        let groups = allGroupsIds.map(groupId => {
            var startIndex = "";
            var endIndex = "";
            var name = "";
            var expandedGroup = "";
            for (var i = 0; i < data.length; i++) {
                if (data[i].aiQuestionGroup.id === groupId) {
                    name = data[i].aiQuestionGroup.name
                    startIndex = startIndex === "" ? i : startIndex
                    endIndex = i + 1
                    expandedGroup = this.groupsCollapsed.length === 0 ?
                        (allTemplateGroupsIds.includes(groupId) ? true : false) :
                        this.groupsCollapsed.filter(g => g.key === groupId)[0]?.isCollapsed
                }
            }
            return ({
                "key": groupId,
                "name": allTemplateGroupsIds.includes(groupId) ? this.context.getTranslation("compliance", "TemplateGroupNameAIAssistant") : this.context.getTranslation("compliance", "CustomGroupNameAIAssistant"),
                "startIndex": startIndex,
                "count": endIndex - startIndex,
                "level": 0,
                "isCollapsed": expandedGroup
            })
        })
        this.groupsCollapsed = groups.map(g => {
            return (
                {
                    key: g.key,
                    isCollapsed: g.isCollapsed
                }
            )
        })
        return groups;
    }

    render() {
        let aIQuestionType = "CUQuestion";
        return (<div style={{ overflow: "auto", maxHeight: window.innerHeight - 120, position: 'relative', marginTop: "5px" }}>

            {/*Manage button add, edit and delete*/}
            <Stack horizontal styles={{ root: { height: 44 } }}>
                <CommandBarButton
                    styles={{ root: { marginTop: 10 } }}
                    iconProps={{ iconName: 'Add' }}
                    text={this.context.getTranslation("compliance", "addCUField")}
                    disabled={false}
                    checked={false}
                    onClick={() => { this.openPanel("addContentUnderstandingField", null) }}
                />
                <CommandBarButton
                    styles={{ root: { marginTop: 10 } }}
                    iconProps={{ iconName: 'Edit' }}
                    text={this.context.getTranslation("compliance", "editCUField")}
                    disabled={false}
                    checked={false}
                    onClick={() => { this.openPanel("editContentUnderstandingField", this.state.aiAssistantId) }}
                />
                <CommandBarButton
                    styles={{ root: { marginTop: 10 } }}
                    iconProps={{ iconName: 'Delete' }}
                    text={this.context.getTranslation("compliance", "deleteCUField")}
                    onClick={this.openDialogDelete}
                />
                <CommandBarButton
                    styles={{ root: { marginTop: 10 } }}
                    iconProps={{ iconName: 'Settings' }}
                    onClick={this.openDialogAiGlobalConf}
                />
            </Stack>

            {/*Warning and error message*/}
            <AlertBar
                message={this.state.warningMessage}
                alertType={this.state.alertType}
                clearAlert={() => { this.setState({ warningMessage: "" }) }}
            />

            {this.state.isProcessing && <Spinner label={this.context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />}

            {/*AIQuestion datailList*/}
            {!this.state.isProcessing && < Stack style={{ marginTop: 10 }}>
                <Query
                    query={queryAIAssistant.queryAllContentUnderstandingQuestions}
                    variables={{ aIQuestionType }}
                    notifyOnNetworkStatusChange={true}
                >
                    {({ loading, error, data, refetch, networkStatus }) => {
                        this.refetchQueryAIAssistant = refetch
                        if (loading) return (
                            <Spinner label={this.context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />
                        )
                        if (error) {
                            console.log(error)
                            return (<AlertBar message={"Error!"} alertType={"error"} />);
                        }
                        if (data.getAIQuestions == null || data.getAIQuestions.length === 0)
                            return (<AlertBar message={this.context.getTranslation("compliance", "noData")} alertType={"warning"} />);
                        //to have always template group up in the table
                        var template = data.getAIQuestions.filter(pr => pr?.aiQuestionGroup?.generalGroup ?? false)
                        var otherGroups = data.getAIQuestions.filter(pr => !pr.aiQuestionGroup.generalGroup)
                        var sortData = [
                            ...template.sort((a,b)=>orderAlphabetically.call(null,a.name.toLowerCase(),b.name.toLowerCase())),
                            ...otherGroups.sort((a,b)=>orderAlphabetically.call(null,a.name.toLowerCase(),b.name.toLowerCase()))
                        ]
                        var groups = this.getAIAssistantGroups(sortData)
                        return (
                            <div>
                                <ContentUnderstandingListView
                                    selectAIAssistant={this.selectAIAssistant}
                                    aiQuestions={sortData}
                                    aiQuestionsGroup={groups}
                                    userRules={this.props.userRules}
                                    getGroupsCollapsed={(groupsCollapsed) => {
                                        this.groupsCollapsed = groupsCollapsed
                                        this.setState({ groupsCollapsed })
                                    }}
                                    groupsCollapsed={this.groupsCollapsed}
                                />
                            </div>
                        )
                    }}
                </Query>
            </Stack>}

            {/*Phrase panel*/}
            <Panel
                isOpen={this.state.isPanelOpen}
                onDismiss={this.hidePanel}
                isFooterAtBottom={false}
                onRenderHeader={this.getHeaderPanel}
                type={PanelType.medium}
            >
                <EditContentUnderstandingContainer
                    apol={this.props.apol}
                    auth={this.props.auth}
                    userRules={this.props.userRules}
                    hidePanel={this.hidePanel}
                    theme={this.props.theme} 
                    aiAssistantId={this.state.panelTitle === "addContentUnderstandingField" ? null : this.state.aiAssistantId}
                    refreshAIAssistant={this.refreshAIAssistant}
                    setMessageError={this.setMessageError} />
            </Panel>

            {/*SafetyDialog for delete AI Question*/}
            <SafetyDialog
                title={this.context.getTranslation("compliance", "deleteAIAssistant")}
                subText={this.context.getTranslation("compliance", "confirmDelete")}
                hideDialog={this.state.hideDialogDelete}
                closeDialog={() => { this.setState({ hideDialogDelete: true }) }}
                ok={this.deleteAIAssistant}
            />
            <TenantAiConfigDlg open={!this.state.hideDialogAiGlobalConfig} 
            theme={this.props.theme}
            onClose={e => this.setState({ hideDialogAiGlobalConfig: true })}
            
            />
        </div>)
    }
}